import { c as _c } from "react/compiler-runtime";
import type { CostWithDiscount, ShippingCosts, SubitoShipping } from 'server/detail-requests/ShippingCost';
import { DiscountedCost } from './DiscountedCost';
import { CourierIcon, DeliveryPointShippingIcon, HomeShippingIcon } from './Icons';
import classes from './index.module.scss';
type SelfShippingRowProps = {
  cost: CostWithDiscount;
};
const SelfShippingRow = t0 => {
  const $ = _c(7);
  const {
    cost
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={classes["icon-wrapper"]}><HomeShippingIcon /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="body-text semibold">Consegna a domicilio</p>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== cost) {
    t3 = <div className={classes["name-and-price"]}>{t2}<DiscountedCost costWithDiscount={cost} /></div>;
    $[2] = cost;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className={`caption book small ${classes["shipping-text"]}`}>Il pacco verrà recapitato all'indirizzo da te scelto</p>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <div className={classes["shipping-cost-wrapper"]}>{t1}<div className={classes["shipping-cost"]}>{t3}{t4}</div></div>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
type TuttoSubitoShippingProps = {
  costs: SubitoShipping;
};
const TuttoSubitoShipping = t0 => {
  const $ = _c(17);
  const {
    costs
  } = t0;
  let t1;
  if ($[0] !== costs.deliveryTime2Shop || $[1] !== costs.minCost2Shop) {
    t1 = costs.minCost2Shop && <><div className={classes["shipping-cost-wrapper"]}><div className={classes["icon-wrapper"]}><DeliveryPointShippingIcon /></div><div className={classes["shipping-cost"]}><div className={classes["name-and-price"]}><div className={classes["cost-with-icon"]}><p className="body-text semibold">Punto di ritiro</p><img id={classes["leaf-icon"]} src="/static/img/tuttosubito/leaf.svg" width="16" height="16" alt="Una scelta sostenibile" loading="lazy" decoding="async" /></div><DiscountedCost costWithDiscount={costs.minCost2Shop} /></div><p className={`caption book small ${classes["shipping-text"]}`}>Ritiro del pacco presso un negozio o un locker</p>{costs.deliveryTime2Shop && <p className="caption small">Consegna prevista entro {costs.deliveryTime2Shop.min}-{costs.deliveryTime2Shop.max} giorni lavorativi</p>}</div></div><p className={`caption book small ${classes["shipping-option-separator"]}`}>Oppure</p></>;
    $[0] = costs.deliveryTime2Shop;
    $[1] = costs.minCost2Shop;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={classes["icon-wrapper"]}><HomeShippingIcon /></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="body-text semibold">Consegna a domicilio</p>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== costs.minCost2Door) {
    t4 = <div className={classes["name-and-price"]}>{t3}<DiscountedCost costWithDiscount={costs.minCost2Door} /></div>;
    $[5] = costs.minCost2Door;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className={`caption book small ${classes["shipping-text"]}`}>Il pacco verrà recapitato all'indirizzo da te scelto</p>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== costs.deliveryTime2Door.max || $[9] !== costs.deliveryTime2Door.min) {
    t6 = <p className="caption small">Consegna prevista entro {costs.deliveryTime2Door.min}-{costs.deliveryTime2Door.max} giorni lavorativi</p>;
    $[8] = costs.deliveryTime2Door.max;
    $[9] = costs.deliveryTime2Door.min;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <div className={classes["shipping-cost-wrapper"]}>{t2}<div className={classes["shipping-cost"]}>{t4}{t5}{t6}</div></div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t1 || $[15] !== t7) {
    t8 = <>{t1}{t7}</>;
    $[14] = t1;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
type ShippingMethodsProps = {
  costs: ShippingCosts;
};
export const ShippingMethods = t0 => {
  const $ = _c(12);
  const {
    costs
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className={`headline-6 ${classes.title}`}>Modalità di consegna</h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = costs.type === "tuttosubito" && costs.minCost2Shop ? "In fase di acquisto potrai scegliere tra queste opzioni" : "In fase di acquisto potrai inserire l'indirizzo";
  let t3;
  if ($[1] !== t2) {
    t3 = <p className={`body-text book small ${classes.subtitle}`}>{t2}</p>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== costs) {
    t4 = <div className={classes["shipping-options"]}>{costs.type === "self" ? <SelfShippingRow cost={{
        partial: false,
        cost: costs.cost
      }} /> : <TuttoSubitoShipping costs={costs} />}</div>;
    $[3] = costs;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== costs.couriers || $[6] !== costs.type) {
    t5 = costs.type === "self" ? <p className={`overline book small ${classes["shipping-type"]}`}>Spedizione gestita dal venditore</p> : <><p className={`overline book small ${classes["shipping-type"]}`}>Spedizione gestita da Subito</p><div className={classes["shipping-icons-container"]}>{costs.couriers.map(_temp)}</div></>;
    $[5] = costs.couriers;
    $[6] = costs.type;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <>{t1}{t3}{t4}{t5}</>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
function _temp(carrierInfo) {
  return <CourierIcon key={carrierInfo.id} id={carrierInfo.id} name={carrierInfo.name} />;
}